<div class="cart-container">
  <div class="right-panel">
    <div class="activate-bar">activate the payment process</div>
    <img src="https://payfast.io/wp-content/uploads/2024/11/White-on-Blue-2-1-1-1-1080x499.jpg.webp" class="payfast-logo" alt="PayFast">
  </div>
  
  <div class="left-panel">
    <img src="../../../assets/images/bizzbean-logo.png" class="logo" alt="BizzBean">
    <button type="button" class="back-btn" (click)="goBack()" title="Go back">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
      Back
    </button>
    <h2 class="title">my cart</h2>
    <h3 class="subtitle">application in cart</h3>
    <table class="cart-table">
      <tr *ngFor="let item of cart">
        <td>
          <input type="checkbox" [checked]="item.selected !== false" (change)="onCheckboxChange(item, $event)">
          {{ item.name }}
        </td>
        <td class="price">{{ item.price | number:'1.2-2' }}</td>
        <td class="remove-cell">
          <button type="button" class="remove-btn" (click)="removeFromCart(item)" title="Remove from cart">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </td>
      </tr>
      <tr class="total-row">
        <td>total value of transaction</td>
        <td class="price">{{ getTotal() | number:'1.2-2' }}</td>
        <td class="remove-cell"></td>
      </tr>
      <tr class="vat-row">
        <td>vat included</td>
        <td class="price">{{ getVat() | number:'1.2-2' }}</td>
        <td class="remove-cell"></td>
      </tr>
    </table>
    
    <div class="cart-actions">
      <button type="button" class="action-btn remove-selected-btn" (click)="removeSelectedItems()" [disabled]="!hasSelectedItems()">
        Remove Selected
      </button>
      <button type="button" class="action-btn clear-cart-btn" (click)="clearCart()" [disabled]="cart.length === 0">
        Clear Cart
      </button>
    </div>
    
    <form>
      <button type="button" class="checkout-btn" (click)="checkout()" [disabled]="cart.length === 0">Proceed to Checkout</button>
    </form>
  </div>
</div>
